export function Ava({ini,color="#1e293b",size=44,photoUrl=""}) {
  return (
    photoUrl
      ? <img src={photoUrl} alt={ini} style={{width:size,height:size,borderRadius:"50%",objectFit:"cover",objectPosition:"top",flexShrink:0,border:`2px solid ${color}55`}}/>
      : <div style={{width:size,height:size,borderRadius:"50%",background:`linear-gradient(135deg,${color},${color}99)`,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,fontSize:Math.max(size*.28,10),flexShrink:0,letterSpacing:"-0.02em"}}>{ini}</div>
  );
}

export default Ava;
